module.exports = __webpack_public_path__ + "static/media/Lens-Bright_HK.ffca3e76.png";